import RippleLoaderGif from '../../../assets/loaders/Ripple-1s-200px.gif';
export const RippleGif = () => {
  return <img src={RippleLoaderGif} />;
};
export default RippleGif;
